<style scoped>
.seg-alt .vs__dropdown-toggle .vs__selected-options .vs__selected {
  overflow: hidden;
  max-width: 65px;
  max-height: 32px;
}
.btn-remove {
  right: 2px;
}
.altura{
  margin: -7px;
}
</style>

<template>
  <div class="dados d-flex">
    <div class="row m-0">
      <div class="col-12">

        <h1 class="font-weight-bold text-uppercase" id="inicio">Meus Dados</h1>

          <div class="d-flex justify-content-end">
            <b-button
              class="mr-3"
              variant="danger"
              @click="$refs.videoManual.toggleOpen({
                url: 'https://www.youtube.com/watch?v=La-FDoECDAs&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=18',
                title: 'Meus Dados'
              })"
            >
              <i class="fas fa-play mr-1"></i>
              Ver video
            </b-button>
            <a class="btn btn-success" href="https://api.construp.com.br/assets/Meus dados.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
          </div>

        <hr class="linha-amarela" />

        <i class="fas fa-hand-holding-usd fa-2x c-orange mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Informações da conta
        </h4>

        <div class="row mt-4">
          <div class="col-lg-4">
            <div class="planos p-t-0">
              <div class="card-plano position-relative" v-if="this.dadosUsuario.informacoes.plano.plano_id === 3">
                <div class="card-header position-relative text-uppercase font-weight-bold text-center fs-22">
                  <div class="checktainer c-c-initial m-0">Meu Plano</div>
                </div>

                <div class="card-body"
                  v-if="
                    dadosUsuario.id != 4402 &&
                    dadosUsuario.id != 4414 &&
                    dadosUsuario.id != 4410 &&
                    dadosUsuario.id != 4412 &&
                    dadosUsuario.id != 4416 &&
                    dadosUsuario.id != 4415 &&
                    dadosUsuario.id != 4417
                  ">
                  <div class="fs-20 text-center text-uppercase" v-if="!comissao && !desativarComissao">
                    4,0% da venda
                  </div>

                  <div class="fs-14 text-center p-4px" v-if="!comissao && !desativarComissao">
                    pela Plataforma
                  </div>

                  <div class="fs-14 text-center p-4px" v-if="!desativarComissao">
                    * Pagamento mínimo mensal de <br>
                    {{ planosApp[0] && planosApp[0].preco ? planosApp[0].preco : '' }}.
                  </div>

                  <div class="fs-14 text-center p-4px" v-if="desativarComissao">
                    * Pagamento mensal de <br>
                    {{ planosApp[0] && planosApp[0].preco ? planosApp[0].preco : '' }}, sem comissão.
                  </div>

                  <div class="fs-14 text-center">
                    <button
                      class="btn bg-orange text-white btn-sm mt-3"
                      @click="showContratoPlano(comissao == false ? 'contrato-lojista-plano-pagamento' : 'contrato-sem-comissao')"
                      v-if="dadosUsuario.id != 4410 && dadosUsuario.id != 4416"
                    >
                      Ver o contrato
                    </button>
                    <button v-if="dadosUsuario.id == 4410" class="btn bg-orange text-white btn-sm mt-3" @click="showContratoPlano('contrato-emporio-app-site')">
                      Ver o contrato
                    </button>
                    <button v-if="dadosUsuario.id == 4416" class="btn bg-orange text-white btn-sm mt-3" @click="showContratoPlano('contrato-jober-app-site')">
                      Ver o contrato
                    </button>
                  </div>
                </div>

                <div class="p-3" v-else>
                  <div class="fs-4 text-center">
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlano('contrato-hidromar-app-site')" v-if="dadosUsuario.id == 4402">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4414)" v-if="dadosUsuario.id == 4414">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4410)" v-if="dadosUsuario.id == 4410">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4412)" v-if="dadosUsuario.id == 4412">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4416)" v-if="dadosUsuario.id == 4416">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4415)" v-if="dadosUsuario.id == 4415">
                      Ver o contrato
                    </button>
                    <button class="btn bg-orange text-white btn-block" @click="showContratoPlanoAws(4417)" v-if="dadosUsuario.id == 4417">
                      Ver o contrato
                    </button>
                  </div>
                </div>
              </div>

              <div class="card-plano position-relative" v-if="this.dadosUsuario.informacoes.plano.plano_id === 1">
                <div>
                  <span class="recomend-span fs-12 font-weight-bold text-uppercase position-absolute">
                    Selecionado
                  </span>
                </div>
                <div class="card-header position-relative text-uppercase font-weight-bold text-center fs-22">
                  <div class="checktainer c-c-initial m-0">Plano 1</div>
                </div>

                <div class="card-body">
                  <div class="fs-28 text-center">R$ 49,90</div>
                  <div class="fs-12 text-center">mensal + 1% da venda</div>
                </div>

                <div class="card-footer p-5px">
                  <div class="w-100 c-pointer btn btn-aceitar-contrato" @click="showContratoPlano('contrato-lojista-plano-1')">
                    Ver o contrato
                  </div>
                </div>
              </div>

              <div class="card-plano position-relative" v-if="this.dadosUsuario.informacoes.plano.plano_id === 2">
                <div>
                  <span class="recomend-span fs-12 font-weight-bold text-uppercase position-absolute">
                    Selecionado
                  </span>
                </div>

                <div class="card-header position-relative text-uppercase font-weight-bold text-center fs-22">
                  <div class="checktainer c-c-initial m-0">Plano 2</div>
                </div>

                <div class="card-body">
                  <div class="fs-20 text-center text-uppercase">
                    2% da venda
                  </div>
                  <div class="fs-12 text-center p-4px">pela Plataforma</div>
                </div>

                <div class="card-footer p-5px">
                  <div class="w-100 c-pointer btn btn-aceitar-contrato" @click="showContratoPlano('contrato-lojista-plano-2')">
                    Ver o contrato
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mt-2">
            <div>
            <h2>Cartão de crédito</h2>
            <p> Tarifas por transação em seu plano <strong>R$ 0,30 + 2,35%</strong> Receba em 30 dias*</p>
            <br>
            <div class="row">
            <div class="col">
              1x= <strong>2.35% </strong><br>
              2x= <strong>2.35% </strong><br>
              3x= <strong>2.35% </strong><br>
              4x= <strong>2.35% </strong><br>
              5x= <strong>2.35% </strong><br>
              6x= <strong>2.35% </strong><br>
            </div>
            <div class="col">
              7x= <strong>2.35% </strong><br>
              8x= <strong>2.35% </strong><br>
              9x= <strong>2.35% </strong><br>
              10x= <strong>2.35% </strong><br>
              11x= <strong>2.35% </strong><br>
              12x= <strong>2.35% </strong><br>
            </div>
            </div>
          </div>
          </div>
          <div class="col-lg-4 mt-2">
            <h2>PIX</h2>
            <p>Tarifas por transação em seu plano: <strong>R$ 0,50</strong></p>
            <br>
            <h2>Boleto Bancário</h2>
            <p>Tarifas por transação em seu plano: <strong>R$ 1,89</strong></p>
          </div>
          <p class="ml-4 mt-2">
            * Transferências só acontecem de segunda a sexta, exceto feriados vigentes no município de São Paulo - Brasil
          </p>
        </div>

        <hr />
        <i class="fas fa-link fa-2x c-orange mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Link de compartilhamento
        </h4>

        <div class="row col">
          <div class="col-md-6 form-group" v-if="android != '' && android != null && android != undefined">
            <label class="font-weight-bold">Link Android:</label><br />
            <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(android)">
              <input type="text" class="form-control" v-model="android" disabled>
              <div class="input-group-prepend">
                <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                  <i class="far fa-copy" style="color:#28a745;"></i>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <span class="d-none">
                <qrcode-vue
                  class="mt-2"
                  :value="android"
                  size=500
                  level="H"
                  id="qrCodeCanvasAndroid"
                />
              </span>
              <qrcode-vue
                class="mt-2"
                :value="android"
                size=120
                level="H"
                id="qrCodeCanvasAndroid"
              />
              <button
                @click="downloadQrCode('qrCodeCanvasAndroid', 'qrcode_android.png')"
                size="sm"
                class="btn btn-outline-success btn-sm"
              >
                <i class="fas fa-download mr-2"></i>
                Baixar qr code
              </button>
            </div>
          </div>

          <div class="col-md-6 form-group" v-if="apple != '' && apple != null && apple != undefined">
            <label class="font-weight-bold">Link Apple:</label>
            <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(apple)">
              <input type="text" class="form-control" v-model="apple" disabled>
              <div class="input-group-prepend">
                <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                  <i class="far fa-copy" style="color:#28a745;"></i>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <span class="d-none">
                <qrcode-vue
                  class="mt-2"
                  :value="apple"
                  size=500
                  level="H"
                  id="qrCodeCanvasApple"
                />
              </span>
              <qrcode-vue
                class="mt-2"
                :value="apple"
                size=120
                level="H"
              />
              <button
                @click="downloadQrCode('qrCodeCanvasApple', 'qrcode_apple.png')"
                size="sm"
                class="btn btn-outline-success btn-sm"
              >
                <i class="fas fa-download mr-2"></i>
                Baixar qr code
              </button>
            </div>
          </div>
        </div>

        <hr />
        <i class="fas fa-user-tie fa-2x c-orange mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Gerente de conta
        </h4>

        <div class="row col">
          <div class="col-md-3 form-group">
            <label class="font-weight-bold">Nome:</label><br />
            <input type="text" class="form-control" v-model="gerente.nome" placeholder="Nome gerente de conta" disabled>
          </div>

          <div class="col-md-3 form-group">
            <label class="font-weight-bold">E-mail:</label><br />
            <input type="text" class="form-control" v-model="gerente.email" placeholder="E-mail gerente de conta" disabled>
          </div>

          <div class="col-md-2 form-group">
            <label class="font-weight-bold">Telefone:</label><br />
            <input type="text" class="form-control" v-model="gerente.telefone" placeholder="(##) ####-####" disabled v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-md-2 form-group">
            <label class="font-weight-bold">WhatsApp:</label><br />
            <input type="text" class="form-control" v-model="gerente.whatsapp" placeholder="(##) # ####-####" disabled v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-md-2 form-group">
            <label class="font-weight-bold">Cód. gerente:</label><br />
            <input type="text" class="form-control" v-model="gerente.cod" placeholder="####" :disabled="validGerente == true">
          </div>

          <div class="col-md-12 text-center my-2">
            <button class="btn btn-success" :disabled="validGerente == true" @click="salvarGerente()">Salvar gerente de conta</button>
          </div>
        </div>

        <hr />
        <i class="fas fa-sign-in-alt fa-2x c-orange mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Dados de Acesso
        </h4>
        <div class="row col">
          <div class="col-md-6 form-group">
            <label for="email" class="font-weight-bold">E-mail:</label><br />
            <input
              type="text"
              class="form-control"
              v-model="dados.email.value"
              :placeholder="dados.email.placeholder"
            />
          </div>

          <div class="col-md-6 form-group">
            <label class="font-weight-bold">Senha:</label><br />
            <input
              type="text"
              class="form-control"
              v-model="dados.senha.value"
              placeholder="************"
            />
          </div>
        </div>

        <hr />

        <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Dados da Conta
        </h4>

        <div class="row">
          <div class="col">
            <div class="row col-12 mt-3">
              <div class="form-group col-md-6">
                <label for="nome" class="font-weight-bold">Razão Social:</label
                ><br />
                <input
                  type="text"
                  class="form-control"
                  v-model="dados.razao_social.value"
                  :placeholder="dados.razao_social.placeholder"
                />
              </div>

              <div class="form-group col-md-6">
                <label class="font-weight-bold">CNPJ:</label><br />
                <input
                  type="text"
                  class="form-control"
                  v-mask="'##.###.###/####-##'"
                  v-model="dados.cnpj.value"
                  :placeholder="dados.cnpj.placeholder"
                />
              </div>

              <div class="form-group col-md-6">
                <label class="font-weight-bold">Nome Fantasia:</label><br />
                <input
                  type="text"
                  class="form-control"
                  v-model="dados.nome_fantasia.value"
                  :placeholder="dados.nome_fantasia.placeholder"
                />
              </div>

              <div class="form-group col-md-6">
                <label class="font-weight-bold">Responsável:</label><br />
                <input
                  type="text"
                  class="form-control"
                  v-model="dados.nome_responsavel.value"
                  :placeholder="dados.nome_responsavel.placeholder"
                />
              </div>
            </div>

            <div class="row col-12"></div>

            <div class="row col-12 mt3">
              <div class="form-group col-md-4">
                <label class="font-weight-bold">Whatsapp:</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['(##) #####-####', '(##) ####-####']"
                  v-model="dados.celular.value"
                  :placeholder="dados.celular.placeholder"
                />
              </div>

              <div class="form-group col-md-4">
                <label for="telefone" class="font-weight-bold">
                  Telefone:
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="'(##) ####-####'"
                  v-model="dados.telefone.value"
                  :placeholder="dados.telefone.placeholder"
                />
              </div>

              <div class="form-group col-md-4">
                <label for="telefone2" class="font-weight-bold">
                  Telefone 2:
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="'(##) ####-####'"
                  v-model="dados.telefone2.value"
                  :placeholder="dados.telefone2.placeholder"
                />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <i class="fa fa-map-marked-alt c-orange fa-2x mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Endereço
        </h4>

        <div class="row col">
          <div class="col-md-4 form-group">
            <label for="" class="font-weight-bold">CEP:</label><br />
            <input
              type="text"
              v-mask="'#####-###'"
              v-model="dados.cep.value"
              @change="consultCep()"
              class="form-control"
              :placeholder="dadosUsuario.informacoes.cep"
            />
          </div>

          <div class="col-md-8 form-group">
            <label for="" class="font-weight-bold">Endereço:</label>
            <div v-if="dados.endereco.show === false">
              <input
                type="text"
                v-model="dados.endereco.value"
                class="form-control"
              />
            </div>
          </div>

          <div class="col-md-4 form-group">
            <label for="" class="font-weight-bold">Numero: </label><br />
            <input
              type="text"
              v-model="dados.numero.value"
              class="form-control"
              :placeholder="dadosUsuario.informacoes.numero"
            />
          </div>

          <div class="col-md-8 form-group">
            <label for="" class="font-weight-bold">Complemento:</label><br />
            <input
              type="text"
              v-model="dados.complemento.value"
              class="form-control"
              :placeholder="dadosUsuario.informacoes.complemento"
            />
          </div>

          <div class="col-md-4 form-group">
            <label for="" class="font-weight-bold">Bairro: </label><br />
            <input
              type="text"
              v-model="dados.bairro.value"
              class="form-control"
              :placeholder="dadosUsuario.informacoes.bairro"
            />
          </div>

          <div class="col-md-4 form-group">
            <label for="" class="font-weight-bold">Cidade:</label>
            <v-select
              disabled
              class="d-inline-block"
              v-model="dados.cidade.value"
              label="nome"
              :options="cidades"
              :placeholder="
                dadosUsuario.informacoes.cidade !== null
                  ? dadosUsuario.informacoes.cidade.nome
                  : ''
              "
            >
              <div slot="no-options">Não encontrou nada.</div>
            </v-select>
          </div>

          <div class="col-md-4 form-group">
            <label for="" class="font-weight-bold">Estado:</label>
            <v-select
              disabled
              class="d-inline-block"
              v-model="dados.estado.value"
              label="uf"
              :options="estados"
              :placeholder="
                dadosUsuario.informacoes.estado !== null
                  ? dadosUsuario.informacoes.estado.uf
                  : ''
              "
            >
              <div slot="no-options">Não encontrou nada.</div>
            </v-select>
          </div>

          <div class="col-12 text-center mt-4">
            <div class="btn btn-success" @click="editarLojista()">
              Salvar dados
            </div>
          </div>
        </div>

        <hr />
        <!-- Segmentos -->
        <i class="fas fa-code-branch fa-2x c-orange mr-2 mb-3"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Segmentos
        </h4>
        <div class="row col-12">
          <div class="col">
            <table class="info m-0">
              <tr>
                <td class="font" style="font-size: 16px">
                  <div
                    class="row m-0"
                    v-if="segmentosUsuario !== null || segmentosUsuario !== []"
                  >
                    <div
                      class="col-8 p-0 mt-1"
                      v-for="(segmento, index) in segmentosUsuario"
                      :key="index"
                    >
                      <div class="btn-remove" @click="excluirSegmentos(index)">
                        <i class="fas fa-times"></i>
                      </div>
                      <v-select
                        class="seg-alt p-right-10px"
                        v-model="segmento.segmento"
                        label="nome"
                        :options="segmentos"
                        placeholder="Digite um segmento"
                      ></v-select>
                    </div>
                  </div>
                  <div class="mt-3">
                    <button
                      class="btn bg-orange text-white mr-3"
                      @click="adicionarSegmentos()"
                    >
                      Adicionar
                    </button>
                    <button class="btn btn-success" @click="salvarSegmentos()">
                      Salvar
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <hr />
        <div class="row col-12">
          <div class="mt-3">
            <AcceptNotifications />
          </div>
        </div>
      </div>
    </div>
    <!-- Contrato Plano 1 -->
    <ShopkeeperContractPlan1
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 1"
    />

    <!-- Contrato Plano 2 -->
    <ShopkeeperContractPlan2
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 2"
    />

    <!-- Contrato Plano 3 -->
    <PaymentPlanContract
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
    />

    <PaymentPlanSemComissao
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
    />

    <PaymentPlanHidromar
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
    />

    <PaymentPlanEmporio
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
    />

    <PaymentPlanJober
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
    />

    <PaymentPlanPdfAws
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 3"
      :contratoDados="urlPdfAws"
    />
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from "vuex";
import ShopkeeperContractPlan1 from "../../components/ShopkeeperContractPlan1.vue";
import ShopkeeperContractPlan2 from "../../components/ShopkeeperContractPlan2.vue";
import PaymentPlanContract from "../../components/PaymentPlanContract.vue";
import PaymentPlanSemComissao from "../../components/PaymentPlanSemComissao.vue";
import PaymentPlanHidromar from "../../components/PaymentPlanHidromar.vue";
import PaymentPlanEmporio from "../../components/PaymentPlanEmporio.vue";
import PaymentPlanPdfAws from "../../components/PaymentPlanPdfAws.vue";
import PaymentPlanJober from "../../components/PaymentPlanJober.vue";
import AcceptNotifications from "../../components/AcceptNotifications";
import makeToast from "../../mixins/makeToast";
import scrollToElement from "../../mixins/scrollToElement";
import validateCpfCnpj from '../../utils/validateCpfCnpj'
import VideoManual from '@/components/VideoManual.vue';
import QrcodeVue from 'qrcode.vue';

export default {
  mixins: [makeToast, scrollToElement],
  name: "dados",
  components: {
    PaymentPlanContract,
    PaymentPlanSemComissao,
    PaymentPlanHidromar,
    PaymentPlanEmporio,
    PaymentPlanPdfAws,
    PaymentPlanJober,
    ShopkeeperContractPlan1,
    ShopkeeperContractPlan2,
    AcceptNotifications,
    VideoManual,
    QrcodeVue
  },
  data: () => ({
    validGerente: false,
    desativarComissao: false,
    comissao: false,
    urlPdfAws: '',
    android: '',
    apple: '',
    planosApp:'',
    gerente: {
      nome: null,
      email: null,
      telefone: null,
      whatsapp: null,
      cod: null,
    },
    dados: {
      email: {
        value: null,
        placeholder: null,
        show: false,
      },
      senha: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_usuario: {
        value: null,
        placeholder: null,
        show: false,
      },
      razao_social: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_fantasia: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_responsavel: {
        value: null,
        placeholder: null,
        show: false,
      },
      cnpj: {
        value: null,
        placeholder: null,
        show: false,
      },
      celular: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone2: {
        value: null,
        placeholder: null,
        show: false,
      },
      endereco: {
        value: null,
        placeholder: null,
        show: false,
      },
      complemento: {
        value: null,
        placeholder: null,
        show: false,
      },
      numero: {
        value: null,
        placeholder: null,
        show: false,
      },
      bairro: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade: {
        value: null,
        placeholder: null,
        show: false,
      },
      estado: {
        value: null,
        placeholder: null,
        show: false,
      },
      cep: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade_id: {
        value: null,
        placeholder: null,
        show: false,
      },
      modificarEndNumShow: false,
      modificarBaiCidEstShow: false,
    },
  }),
  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
      segmentos: (state) => state.segmentos,
      segmentosUsuario: (state) => state.dadosUsuario.informacoes.segmentos,
    }),
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  created() {
    if(this.dadosUsuario.desativar_comissao && this.dadosUsuario.desativar_comissao) {
      this.desativarComissao = true;
    }

    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadSegmentos');
    this.scrollToElement();
    this.buscarGerente();
    this.buscarLinks();
    this.showPlanos();
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.dados.email.placeholder = this.dadosUsuario.email;
    this.dados.nome_usuario.placeholder = this.dadosUsuario.nome_usuario;
    this.dados.razao_social.placeholder = this.dadosUsuario.informacoes.razao_social;
    this.dados.nome_fantasia.placeholder = this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.nome_responsavel.placeholder = this.dadosUsuario.informacoes.nome_responsavel;
    this.dados.cnpj.placeholder = this.dadosUsuario.cnpj;
    this.dados.celular.placeholder = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.placeholder = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.placeholder = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.placeholder = this.dadosUsuario.informacoes.endereco;
    this.dados.complemento.placeholder = this.dadosUsuario.informacoes.complemento;
    this.dados.numero.placeholder = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.placeholder = this.dadosUsuario.informacoes.bairro;

    if (this.dadosUsuario.informacoes.cidade !== null) {
      this.dados.cidade.placeholder = this.dadosUsuario.informacoes.cidade.nome;
    }

    if (this.dadosUsuario.informacoes.estado !== null) {
      this.dados.estado.placeholder = this.dadosUsuario.informacoes.estado.uf;
    }

    this.dados.cep.placeholder = this.dadosUsuario.informacoes.cep;

    this.dados.email.value = this.dadosUsuario.email;
    this.dados.nome_usuario.value = this.dadosUsuario.nome_usuario;
    this.dados.razao_social.value = this.dadosUsuario.informacoes.razao_social;
    this.dados.nome_fantasia.value = this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.nome_responsavel.value = this.dadosUsuario.informacoes.nome_responsavel;
    this.dados.cnpj.value = this.dadosUsuario.cnpj;
    this.dados.celular.value = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.value = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.value = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.value = this.dadosUsuario.informacoes.endereco;
    this.dados.complemento.value = this.dadosUsuario.informacoes.complemento;
    this.dados.numero.value = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.value = this.dadosUsuario.informacoes.bairro;
    this.dados.cidade.value = this.dadosUsuario.informacoes.cidade;
    this.dados.estado.value = this.dadosUsuario.informacoes.estado;
    this.dados.cep.value = this.dadosUsuario.informacoes.cep;
  },

  beforeUpdate() {
    if (this.$router.history.current.name === 'cadastro') {
      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: "area-restrita" });
        this.scrollToElement();
      }
    }
  },

  methods: {
    downloadQrCode(elementId, fileName){
      var qrCodeCanvas = document.getElementById(elementId).getElementsByTagName('canvas');
      var dataUrl = qrCodeCanvas[0].toDataURL();

      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      xhr.open('GET', dataUrl);
      xhr.send();
    },
    abrirContrato() {

    },
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosAppLojistaId', this.dadosUsuario.id)
      .then((response) => {
        this.planosApp = response.data.data;
        this.comissao = response.data.comissao;
        this.$store.dispatch('endLoader');
      })
    },
    consultCep() {
      if (!this.loading && this.dados.cep.value.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.dados.cep.value)
          .then(async (response) => {
            this.dados.endereco.value = response.data.logradouro || null;
            this.dados.bairro.value = response.data.bairro || null;
            this.dados.cidade.value = response.data.localidade || null;
            this.dados.cidade_id.value = {
              "id": response.data.cidade_id || null,
              "nome": response.data.localidade || null,
              "estado_id": response.data.uf || null,
            }
            this.dados.estado.value = this.estados.find(estado=>
              estado.uf === response.data.uf) || null
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }
    },
    buscarGerente() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/buscarGerenteId', this.dadosUsuario.informacoes.id)
        .then((response) => {
          if(response.data.gerente == true) {
            const gerente = response.data.data;
            this.gerente.nome = gerente.nome+' '+gerente.sobrenome;
            this.gerente.email = gerente.email;
            this.gerente.telefone = gerente.telefone;
            this.gerente.whatsapp = gerente.whatsapp;
            this.gerente.cod = gerente.cod;
            this.validGerente = true;
          }
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    buscarLinks() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/buscarLinksId', this.dadosUsuario.id)
        .then((response) => {
          this.android = response.data.link_android;
          this.apple = response.data.link_apple;
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao buscar links!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    salvarGerente() {
      if(this.gerente.cod == null || this.gerente.cod == '') {
        this.makeToast('Oopss', 'Informe o código do seu gerente de vendas!', 'danger')
        return;
      }

      const data = {
        lojista_id: this.dadosUsuario.informacoes.id,
        gerente_id: this.gerente.cod
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/vincularGerente', data)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', response.data.message, 'success')
            this.buscarGerente();
          } else {
            this.makeToast('Oopss', response.data.message, 'danger')
          }
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao vincular gerente!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },

    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    modificarEndNum() {
      this.dados.endereco.show = !this.dados.endereco.show;
      this.dados.numero.show = !this.dados.numero.show;
      this.dados.modificarEndNumShow = !this.dados.modificarEndNumShow;
    },
    modificarBaiCidEst() {
      this.dados.bairro.show = !this.dados.bairro.show;
      this.dados.cidade.show = !this.dados.cidade.show;
      this.dados.estado.show = !this.dados.estado.show;
      this.dados.modificarBaiCidEstShow = !this.dados.modificarBaiCidEstShow;
    },
    verificaEdicao() {
      if (
        this.dados.email.show !== false ||
        this.dados.senha.show !== false ||
        this.dados.nome_usuario.show !== false ||
        this.dados.razao_social.show !== false ||
        this.dados.nome_fantasia.show !== false ||
        this.dados.nome_responsavel.show !== false ||
        this.dados.cnpj.show !== false ||
        this.dados.celular.show !== false ||
        this.dados.telefone.show !== false ||
        this.dados.telefone2.show !== false ||
        this.dados.endereco.show !== false ||
        this.dados.complemento.show !== false ||
        this.dados.numero.show !== false ||
        this.dados.bairro.show !== false ||
        this.dados.cidade.show !== false ||
        this.dados.estado.show !== false ||
        this.dados.cep.show !== false
      ) {
        return true;
      }
      return false;
    },
    editarLojista() {
      const data = {
        id: this.dadosUsuario.id,
        id_lojista: this.dadosUsuario.informacoes.id,
      };

      if(validateCpfCnpj('cnpj', this.dados.cnpj.value)==false){
        this.makeToast(
          'Erro',
          'CNPJ não é válido, favor verificar!',
          'danger'
        );
        return
      }

      Object.assign(data, { email: this.dados.email.value });
      Object.assign(data, { razao_social: this.dados.razao_social.value });
      Object.assign(data, { nome_fantasia: this.dados.nome_fantasia.value });
      Object.assign(data, {nome_responsavel: this.dados.nome_responsavel.value});
      Object.assign(data, { cnpj: this.dados.cnpj.value });
      Object.assign(data, { celular: this.dados.celular.value });
      Object.assign(data, { telefone: this.dados.telefone.value });
      Object.assign(data, { telefone2: this.dados.telefone2.value });
      Object.assign(data, { endereco: this.dados.endereco.value });
      Object.assign(data, { complemento: this.dados.complemento.value });
      Object.assign(data, { numero: this.dados.numero.value });
      Object.assign(data, { bairro: this.dados.bairro.value });
      Object.assign(data, { cidade: this.dados.cidade.value.id ? this.dados.cidade.value : this.dados.cidade_id.value });
      Object.assign(data, { estado: this.dados.estado.value });
      Object.assign(data, { cep: this.dados.cep.value });

      if (this.dados.senha.value !== null) {
        Object.assign(data, { password: this.dados.senha.value });
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateLojista', data)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Dados atualizados com sucesso!',
            'success'
          );
          this.dados.email.show = false;
          this.dados.senha.show = false;
          this.dados.nome_usuario.show = false;
          this.dados.razao_social.show = false;
          this.dados.nome_fantasia.show = false;
          this.dados.nome_responsavel.show = false;
          this.dados.cnpj.show = false;
          this.dados.celular.show = false;
          this.dados.telefone.show = false;
          this.dados.telefone2.show = false;
          this.dados.endereco.show = false;
          this.dados.complemento.show = false;
          this.dados.numero.show = false;
          this.dados.bairro.show = false;
          this.dados.cidade.show = false;
          this.dados.estado.show = false;
          this.dados.cep.show = false;
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao atualizar!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    adicionarSegmentos() {
      this.segmentosUsuario.push({
        segmento: {
          nome: 'Segmento',
        },
      });
    },
    salvarSegmentos() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        segmentos: this.segmentosUsuario,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateSegmentosLojista', data)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Segmentos atualizados com sucesso!',
            'success'
          );
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao atualizar!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    excluirSegmentos(index) {
      this.segmentosUsuario.splice(index, 1);
    },
    showContratoPlano(idPlano) {
      this.$bvModal.show(idPlano);
    },
    showContratoPlanoAws(idPlano) {
      if(idPlano == 4414) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Contrato+FCF+FERRAMENTAS+%5Bassinado%5D.pdf'
      } else if(idPlano == 4410) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Contrato+Emporio+dos+metais+-+Constr+Up+%5Bassinado%5D+(1).pdf'
      } else if(idPlano == 4412) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Lider+Mat+Contrato+(1)+%5Bassinado%5D.pdf'
      } else if(idPlano == 4416) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Contrato+Jober+%5Bassinado%5D.pdf'
      } else if(idPlano == 4415) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Contrato+Santa+Odila+%5Bassinado%5D.pdf'
      } else if(idPlano == 4417) {
        this.urlPdfAws = 'https://construp-imagens.s3.us-east-2.amazonaws.com/pdf/Contrato+Universo+do+Construtor+%5Bassinado%5D.pdf'
      }
      this.$bvModal.show('contrato-pdf-aws-app-site');
    },
    hideContratoPlano(idPlano) {
      this.$bvModal.hide(idPlano);
    },
  },
};
</script>
<style scoped>
.mg-r
{
  margin-right: -120px;
  margin-bottom: 25px;
}
.mg-t
{
  margin-top: -15px;
  margin-bottom: 25px;
}
.mg-l {
  margin-left: 15px;
  margin-top: -15px;
  margin-bottom: 25px;
}
h2
{
  color: #ED670C ;
}
</style>
